import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Modal,
  ButtonToolbar,
  OverlayTrigger,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";

export const ErrorPermissionPage = () => {
  return (
    <>
      <Card>
        <CardBody>
          <p className="font-weight-bolder text-dark-75 font-size-lg">
            You Dont Have permissions in this Modul
          </p>
        </CardBody>
      </Card>
    </>
  );
};
